import * as React from "react"
import { cn } from "@/shared/utils"

interface TooltipProps {
  content: string;
  side?: "top" | "right" | "bottom" | "left";
  children: React.ReactNode;
  className?: string;
}

const positionClasses: Record<string, string> = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
  right: "left-full top-1/2 -translate-y-1/2 ml-2",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
  left: "right-full top-1/2 -translate-y-1/2 mr-2",
};

export function Tooltip({ content, side = "right", children, className }: Readonly<TooltipProps>) {
  return (
    <span className="group/tooltip relative inline-flex">
      {children}
      <span
        className={cn(
          "pointer-events-none absolute z-50 whitespace-nowrap rounded-md bg-popover px-3 py-1.5 text-xs font-medium text-popover-foreground shadow-md border",
          "opacity-0 scale-95 transition-all group-hover/tooltip:opacity-100 group-hover/tooltip:scale-100",
          positionClasses[side],
          className,
        )}
        role="tooltip"
      >
        {content}
      </span>
    </span>
  );
}
